export enum CENTRIX_META {
  CENTRIX_CREDIT_FILE_NAME = 'centrix-creditFile',
  CENTRIX_JSON_FILE_NAME = 'centrixCompleteJSON.json',
  LOAN_APPLICATION_FILE_LABEL_CREDIT_FILE_JSON = 'creditFileJSON',
}

export enum CENTRIX_BUREAU_META {
  CENTRIX_MAX_RETRY = 3,
  TIME_BEFORE_NEXT_RETRY_IN_MS = 1000,
}
